@use '../../../../styles/Constants.scss' as Constants;
@use '../../../../styles/Colors.scss' as Colors;

.calendar-icon {
	color: Colors.$col-blackDark;
}

.error-msg{
	color: Colors.$col-red;
	font-weight: bold;
	width: 100%;
	font-size: Constants.$val-fontSizeRegular;
}